import React from 'react';
import { Box, Container, Typography, Button, Grid, useTheme, Stack } from '@mui/material';
import {
  CheckCircle,
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';

const switchingPoints = [
  'Import your services and go live in under 5 minutes',
  'Syncs with Google Calendar — keep your existing workflow',
  'Free core tools. Pay only for AI features you actually use',
  'No contracts, cancel anytime'
];

const SwitchingSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        position: 'relative',
        background: '#000000'
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Box
            sx={{
              background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(37, 99, 235, 0.05) 100%)',
              border: '1px solid rgba(37, 99, 235, 0.2)',
              borderRadius: 5,
              p: { xs: 4, md: 8 },
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
              <Grid item xs={12} md={7}>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 800,
                    color: '#ffffff',
                    mb: 2,
                    fontSize: { xs: '2rem', md: '2.8rem' },
                    letterSpacing: '-0.03em'
                  }}
                >
                  Your new business manager.
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    color: theme.palette.text.secondary,
                    mb: 4,
                    maxWidth: 560,
                    lineHeight: 1.6,
                    fontWeight: 400
                  }}
                >
                  FutureSense is the AI-first assistant that handles your bookings, 
                  reminders, and retention — so you can focus on the craft that actually pays.
                </Typography>

                <Stack spacing={2}>
                  {switchingPoints.map((point) => (
                    <Box key={point} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <CheckCircle sx={{ fontSize: 20, color: theme.palette.primary.main }} />
                      <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.8)', fontWeight: 500 }}>
                        {point}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Grid>

              <Grid item xs={12} md={5}>
                <Stack spacing={2} alignItems={{ xs: 'stretch', md: 'center' }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate(ROUTES.SIGNUP)}
                    fullWidth
                    sx={{ py: 2, px: 4, fontSize: '1.05rem' }}
                  >
                    Get Started Free
                  </Button>

                  <Button
                    variant="outlined"
                    size="large"
                    onClick={() => navigate(ROUTES.FEATURES)}
                    fullWidth
                    sx={{ py: 2, px: 4, fontSize: '1.05rem' }}
                  >
                    Explore Features
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default SwitchingSection;
